import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { Breakpoint } from '@travel-frontend/core';
import { IconAccessibility, IconChevronLeft, IconChevronRight } from '@travel-frontend/icons';
import Cookies from 'js-cookie';
import { useTranslation } from 'next-i18next';
import { AccessibilityButton } from '../../../../components/Header/components/TopBar/AccessibilityButton.js';
import { AccessibilityLink } from '../../../../components/Header/components/TopBar/AccessibilityLink.js';
import { Flex } from '../../../../primitives/index.js';
export const AccessibilityToggle = ({
  handleAccessibilityToggleClick
}) => {
  const {
    isAccessibleTheme
  } = useTheme();
  const {
    t
  } = useTranslation('header');
  const onAccessibilityToggleClick = () => {
    Cookies.set('isAccessibleThemeEnabled', String(!isAccessibleTheme));
    handleAccessibilityToggleClick();
  };
  return _jsxs(Flex, {
    direction: "row",
    alignItems: "center",
    spacing: "0",
    children: [_jsxs(AccessibilityButton, {
      size: "small",
      onClick: onAccessibilityToggleClick,
      children: [_jsx(IconAccessibility, {}), _jsx(Breakpoint, {
        matches: ['lg', 'xl', 'md'],
        children: _jsxs(Flex, {
          direction: "row",
          alignItems: "center",
          spacing: "2px",
          children: [isAccessibleTheme ? t('accessibilityToggle.disable') : t('accessibilityToggle.enable'), isAccessibleTheme ? _jsx(IconChevronLeft, {}) : _jsx(IconChevronRight, {})]
        })
      })]
    }), _jsx(Breakpoint, {
      matches: ['sm', 'xs'],
      children: _jsx(AccessibilityLink, {
        onClick: onAccessibilityToggleClick,
        children: isAccessibleTheme ? t('accessibilityToggle.disable') : t('accessibilityToggle.enable')
      })
    })]
  });
};